// Marca de "dado novo" do feed de atividade (botão "Novos dados" da home). Função pura — a
// re-ancoragem some tanto pra cima (evento chegou) quanto pra baixo (feed encolheu) e não vale a
// pena testar via effect() do componente (exigiria TestBed com Keycloak/ActivityService/Router).

export interface FreshnessMark {
  /** Total de eventos do feed na última vez que o painel carregou. */
  seen: number;
  /** Números da tela possivelmente defasados → oferece o refresh. */
  fresh: boolean;
}

/**
 * Feed cresceu (evento novo chegou) → acende o aviso, marca não muda (só o próximo load reancora
 * pra cima). Feed encolheu (botão "Limpar" da navbar zera/reduz o feed) → reancora `seen` pro novo
 * total, mas SEM mexer em `fresh`: um aviso legítimo não pode ser apagado por limpeza do feed, e
 * limpar também não pode fabricar aviso novo. Sem mudança → marca igual.
 */
export function nextFreshness(mark: FreshnessMark, feedCount: number): FreshnessMark {
  if (feedCount > mark.seen) return { seen: mark.seen, fresh: true };
  if (feedCount < mark.seen) return { seen: feedCount, fresh: mark.fresh };
  return mark;
}
